import { render, staticRenderFns } from "./SvgSprites.vue?vue&type=template&id=1319ea88&"
import script from "./SvgSprites.vue?vue&type=script&lang=js&"
export * from "./SvgSprites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports